var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.156 48.9844L77.4219 27.2656C76.7969 26.875 75.9375 26.7188 75 26.7188C74.0625 26.7188 73.2031 26.9531 72.5781 27.2656L35.0781 49.0625C33.75 49.8438 32.8125 51.7969 32.8125 53.2813V96.7969C32.8125 97.6563 32.9687 98.6719 33.5938 99.5313L117.031 51.0938C116.563 50.1563 115.859 49.4531 115.156 48.9844V48.9844Z",
    fill: "#D26383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3594 99.4531C33.75 100.078 34.2969 100.625 34.8438 100.937L72.5 122.734C73.125 123.125 73.9844 123.281 74.9219 123.281C75.8594 123.281 76.7188 123.047 77.3438 122.734L114.844 100.937C116.172 100.156 117.109 98.2031 117.109 96.7188V53.2031C117.109 52.5 117.031 51.7187 116.641 51.0156L33.3594 99.4531V99.4531Z",
    fill: "#9C033A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6406 84.4531C88.3594 90.2344 82.1094 94.1406 75 94.1406C64.4531 94.1406 55.8594 85.5469 55.8594 75C55.8594 64.4531 64.4531 55.8594 75 55.8594C82.1094 55.8594 88.3594 59.7656 91.6406 65.625L101.797 59.7656C96.4844 50.4688 86.4844 44.1406 75 44.1406C57.9688 44.1406 44.1406 57.9688 44.1406 75C44.1406 92.0312 57.9688 105.859 75 105.859C86.4063 105.859 96.4062 99.6094 101.719 90.3906L91.6406 84.4531V84.4531Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1406 73.2812H93.2031V69.1406H96.6406V73.2812H100.781V76.7187H96.6406V80.7813H93.2031V76.7187H89.1406V73.2812V73.2812ZM103.594 73.2812H107.656V69.1406H111.094V73.2812H115.234V76.7187H111.094V80.7813H107.656V76.7187H103.594V73.2812V73.2812Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpp);
export default __webpack_public_path__ + "static/media/Cpp.5e6913f87fa6ba2d56af14a6766dc3cd.svg";
export { ForwardRef as ReactComponent };